export enum StaticFieldIds {
  Project = 'project',
  Team = 'team',
  CreatedBy = 'createdBy',
  CreatedAt = 'createdAt',
  FormNumber = 'formNumber',
  WorkflowStep = 'workflowStep',
  FormVersion = 'formVersion',
  UpdatedAt = 'updatedAt',
  Id = '_id',
}
